import React, { FC, useEffect, useState } from "react";
import * as Highcharts from "highcharts";
import { EfficiencyElement } from "../../index";
import { useWideScreen } from "../../../../../../../../hooks/useWideScreen";
import LinearChart from "../../../../../../../../components/modules/dashboards/сharts/defaultCharts/linearChart/LinearChart";
import { applyTip } from "../../../../../../../../utils/utils";
import BaseChartTooltip from "../../../../../../../../components/modules/dashboards/dashboardTooltips/TooltipVariants/BaseChartTooltip/BaseChartTooltip";

type EfficiencyCircleChartProps = {
    chartCallback?: Highcharts.ChartCallbackFunction
    elements: EfficiencyElement[]
}

const EfficiencyCircleChart: FC<EfficiencyCircleChartProps> = (props) => {
    const { chartCallback, elements } = props

    const [chartOptions, setChartOptions] = useState<Highcharts.Options>({ title: { text: '' } })

    const isWideScreen = useWideScreen()

    useEffect(() => {
        const defaultOptions: Highcharts.Options = {
            chart: {
                backgroundColor: 'transparent',
                height: isWideScreen ? 300 : 200,
                margin: 0,
                spacing: [0, 0, 0, 0]
            },
            title: {
                text: ''
            },
            tooltip: applyTip((ctx) => {
                return (
                    <BaseChartTooltip
                        elements={[{
                            name: ctx.point?.name || '',
                            color: ctx.point?.color as string || '',
                            id: ctx.point?.name || ''
                        }]}
                    />
                )
            }),

            legend: {
                enabled: false,
            },

            credits: {
                enabled: false
            },

            plotOptions: {
                pie: {
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: false,
                        format: `<div style="color:black">{point.y} {point.dimension}</div> `,
                        style: {
                            fontWeight: 'normal',
                        }
                    },
                    showInLegend: true
                }
            },

            series: [
                {
                    innerSize: '60%',
                    type: 'pie',
                    data: elements.map(item => ({
                        ...item,
                        id: item.id,
                        name: item.name,
                        y: item.duration,
                    }))
                }
            ]
        }
        setChartOptions(defaultOptions)
    }, [elements, isWideScreen])

    return (
        <LinearChart
            containerProps={{ style: { height: isWideScreen ? 300 : 200, width: "100%" } }}
            callback={chartCallback}
            options={chartOptions}
        />
    )
}

export default EfficiencyCircleChart;